import { UpperCasePipe } from '@angular/common';
import {
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { DvButtonComponent } from '@devinco/ui/dds';
import { TranslateModule } from '@ngx-translate/core';
import { UserLogEventType } from '@shared/constants/user-log-event-type';
import { UserLogEventService } from '@shared/services/user-log-event.service';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { take } from 'rxjs';

@Component({
  imports: [DvButtonComponent, TranslateModule, UpperCasePipe],
  selector: 'app-no-rights',
  templateUrl: './no-rights.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./no-rights.component.scss'],
})
export class NoRightsComponent implements OnInit {
  private oidcService = inject(OidcSecurityService);
  private userEventLogService = inject(UserLogEventService);

  userName: string;

  ngOnInit(): void {
    this.oidcService
      .getUserData()
      .pipe(take(1))
      .subscribe(({ email }) => {
        this.userName = email;
      });
  }

  onOkClick(): void {
    this.userEventLogService.logEvent(UserLogEventType.UserLogout);
    this.oidcService.logoff().subscribe();
  }
}
